import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModules } from '../@prime-ng/primeng.module';
import { AmigaPymeComponents } from './components';

@NgModule({
  imports: [...PrimeNgModules, FormsModule, ReactiveFormsModule],
  declarations: [...AmigaPymeComponents],
  exports: [...AmigaPymeComponents]
})
export class AmigaPymeModule {}
